<!-- Templates -->
<ng-template
  #innerHTMLTemplate
  let-content>
  <div [innerHTML]="content | safe: 'html'"></div>
</ng-template>

<ng-template
  #templateRef
  let-content>
  <ng-container
    [ngTemplateOutlet]="content"
    [ngTemplateOutletContext]="{ $implicit: alertRef, context }" />
</ng-template>

<!-- Icon -->
@if (icon) {
  <div class="alert-icon_wrapper">
    <span [ngClass]="getAlertIcon"></span>
  </div>
}

<!-- Content -->
<div class="alert-content">
  @if (content) {
    <ng-container
      [ngTemplateOutlet]="isTemplate(content) ? templateRef : innerHTMLTemplate"
      [ngTemplateOutletContext]="{ $implicit: content }" />
  } @else {
    <ng-content />
  }
</div>

<!-- Button close -->
@if (closable) {
  <div class="alert-close_wrapper">
    <mbs-button
      class="alert-close"
      [icon]="'ico ico-Close'"
      [isCtrl]="true"
      [size]="size === MbsSize.lg ? MbsSize.xs : MbsSize.xxs"
      [type]="'dark'"
      (click)="closeAlert(alertRef)" />
  </div>
}
